export const FLAG_EN = 'en'
export const FLAG_CS = 'cs'
